// components/Loader.js
import React from 'react';
import { motion } from 'framer-motion';

const Loader = () => {
  return (
    <div className="flex flex-col items-center justify-center space-y-4">
      <motion.div
        className="h-16 w-16 rounded-full border border-black border-t-transparent dark:border-white dark:border-t-transparent"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: 'linear' }}
      />
      <motion.p
        className="text-xs font-semibold uppercase tracking-[0.24em] text-gray-700 dark:text-gray-300"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ repeat: Infinity, duration: 1.5, repeatType: 'reverse' }}
      >
        Loading...
      </motion.p>
    </div>
  );
};

export default Loader;
